import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/header.tsx");
